import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import ButtonCollapse from './ButtonCollapse';

export default function CpaInfo({ templateId }) {
  const mainText = (
    <>
      What Are Your Specific Coaching Goals? What Are Your Current &lsquo;Coordinates&rsquo;?
      Take Your Talent Assessment. Check Recommended LeggUP Development Plans.
      Start Your LeggUP Membership.
    </>
  );

  const mobileVersion = (
    <Col className="main d-md-none">
      <div id={templateId} className={`${templateId} collapse fw-light`}>
        {mainText}
      </div>

      <ButtonCollapse templateId={templateId} />
    </Col>
  );

  return (
    <>
      {mobileVersion}

      <Col md="6" className="main d-none d-md-block">
        <div className="fw-light">
          {mainText}
        </div>
      </Col>
    </>
  );
}

CpaInfo.propTypes = {
  templateId: PropTypes.string.isRequired,
};
